document.querySelectorAll("[data-copy-link]").forEach((btn) => {
  btn.addEventListener("click", () => {
    navigator.clipboard.writeText(window.location.href);
    console.log("clicked");
  });
});
